/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { useEffect, useMemo, useState } from "react";
import {
  companies,
  documents,
  documentsDetails,
  documentsUpload,
  dsr_report_endpoint,
  jobId,
  retailers,
  runDocument,
  runErpReprocess,
  users,
  workflow,
} from "@/services/global.services";

import { useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import useAutoPolling from "@/hooks/use-auto-polling";
import { useParentDocument } from "@/global-data/use-parent-document";
import { DateObject } from "react-multi-date-picker";
import { format } from "date-fns";
import { getCurrentTimeZone } from "@/lib/utils";
import { getFileUrl } from "@/lib/get-file-url";

export const useMutations = () => {
  const timeZone = getCurrentTimeZone();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [reprocessDocumentId, setReprocessDocumentId] = useState(undefined);
  const [reprocessErpId, setReprocessErpId] = useState(undefined);
  const filterParam = searchParams.get("filter");
  const parent_id = searchParams.get("parent");
  const [autoPolling, setAutoPolling] = useState(true);
  const [dashboardDetails, setDashboardDetails] = useState(undefined);
  const [selectedRecord, setSelectedRecord] = useState<string[]>([]);
  const [currentUser, setCurrentUser] = useState<any>(undefined);
  const [isAdmin, setIsAdmin] = useState<any>(false);
  const [tempDate, setTempDate] = useState<any>(undefined);

  const API_URL = useMemo(() => {
    return documents;
  }, [documents]);
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const pageReset = searchParams.get("page");

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [retailerList, _setRetailerList] = useState([]);
  const [allRetailerList, setAllRetailerList] = useState([]);
  const [currentCompanyData, setCurrentCompanyData] = useState<any>([]);
  const [companyData, _setCompanyData] = useState([]);
  const [workflowList, setWorkflowList] = useState([]);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState(undefined);
  const [tableColumn, setTableColumn] = useState([]);
  const [deleteId, setDeleteId] = useState(undefined);
  const { setSearchProgress, search } = useGlobalSearch();
  const [searchDebounced] = useDebouncedValue(search, 200);
  const [filter, setFilter] = useState<any>({});
  const [formPopup, setFormPopup] = useState<boolean>(false);
  const [dateRangeBy, setDateRangeBy] = useState<
    "processed_date" | "delivery_date" | "order_date"
  >("processed_date");

  const [dateFilter, setDateFilter] = useState<any>();

  const fetchData = async () => {
    await loadingList({ isRePolling: true });
  };

  const { startPolling, stopPolling } = useAutoPolling(fetchData, 5000);
  const { setParent, parent } = useParentDocument();
  const { toast } = useToast();

  const { onDelete, status, identity, clearDelete } = useDeletePopup();

  const [paginationData, setPaginationData] = useState({
    page: sessionStorage.getItem("document-page")
      ? Number(sessionStorage.getItem("document-page"))
      : 1,
    perPage: sessionStorage.getItem("document-perPage")
      ? Number(sessionStorage.getItem("document-perPage"))
      : 10,
    totalItem: 1,
  });

  useEffect(() => {
    if (autoPolling) {
      startPolling();
    } else {
      stopPolling();
    }
  }, [autoPolling]);

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      sessionStorage.setItem("document-filter", JSON.stringify(filter));
    }
  }, [filter]);

  const { pathname } = location;

  const getRangeDate = (keys: string) => {
    try {
      const tempDate = sessionStorage.getItem(keys);
      return JSON.parse(tempDate || "");
    } catch (error) {
      const end = new DateObject().format("DD-MM-YYYY");
      const startDate = new DateObject().subtract(6, "days").toDate();

      const start = format(startDate, "dd-MM-yyyy"); // using date-fns

      return [start, end];
    }
  };

  useEffect(() => {
    (async () => {
      if (pageReset) {
        setSearchParams({});
        sessionStorage.removeItem("parent");
        sessionStorage.setItem("document-page", "1");
        const dateRange = getRangeDate("parent-date-filter");
        setProcess(true);
        await loadingList({
          searchText: "",
          dateRange: dateRange || [],
          page: 1,
        });
        setProcess(false);
      }
    })();
  }, [pageReset]);

  //On Load Component
  useEffect(() => {
    let predefinedFilter = sessionStorage.getItem("document-filter");
    let statusFilterRemoved = false;
    // Coming back to the list always starts without a status tab / Deleted
    // filter; other column filters are kept
    if (predefinedFilter) {
      try {
        const savedFilter = JSON.parse(predefinedFilter);
        statusFilterRemoved =
          savedFilter?.state?.length > 0 || savedFilter?.is_deleted === true;
        delete savedFilter.state;
        delete savedFilter.is_deleted;
        if (Object.keys(savedFilter).length > 0) {
          predefinedFilter = JSON.stringify(savedFilter);
          sessionStorage.setItem("document-filter", predefinedFilter);
        } else {
          predefinedFilter = null;
          sessionStorage.removeItem("document-filter");
        }
      } catch (error) {
        console.error(error);
      }
    }
    if (statusFilterRemoved) {
      sessionStorage.setItem("document-page", "1");
    }
    let parent = sessionStorage.getItem("parent");
    const removeParent = sessionStorage.getItem("remove_parent");
    if (removeParent) {
      sessionStorage.removeItem("remove_parent");
      parent = null;
    }
    const key = parent ? `search-${pathname}-parent` : `search-${pathname}`;
    const current_page = sessionStorage.getItem("document-page");

    setPaginationData((prev) => ({
      ...prev,
      page: current_page ? Number(current_page) : 1,
    }));

    let dateRange = [];
    if (parent) {
      dateRange = getRangeDate("parent-date-filter");
    } else {
      dateRange = getRangeDate("date-filter");
    }

    if (dateRange?.[0] && dateRange?.[1]) {
      setDateFilter(dateRange);
    } else {
      const startDate = new DateObject({ format: "DD-MM-YYYY" }).subtract(
        6,
        "days",
      );
      const endDate = new DateObject({ format: "DD-MM-YYYY" });
      //  setDateFilter;
      setDateFilter([startDate, endDate]);
      dateRange = [startDate, endDate];
    }

    let searchText = sessionStorage.getItem(key);

    if (filterParam) {
      const customFilter = JSON.parse(filterParam);
      if (customFilter?.state?.[0]) {
        searchText = customFilter?.state?.[0];
      }
    }

    (async () => {
      if (parent) {
        setSearchParams({ parent: parent });
        setParent(parent);
      }
      await loadingList({
        predefinedFilter,
        current_parent_id: parent,
        searchText: searchText || "",
        dateRange,
        page: current_page ? Number(current_page) : 1,
      });
      await loadingRetailer();
      await loadUser();
      await wait(1000);
      setSkeltonLoading(false);
      setIsLoading(true);
    })();
  }, []);

  const loadUser = async () => {
    const payload = {
      data: {
        user_id: user_id,
        filter_by: {
          user_id: user_id,
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices(
      users.get,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    if (data?.result?.metadata?.users?.[0]) {
      const linked_customer =
        data?.result?.metadata?.users?.[0]?.linked_customer;
      setCurrentUser(data?.result?.metadata?.users?.[0]);
      if (linked_customer == "" || !linked_customer) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    }
  };

  const loadingRetailer = async (retailerProp?: any) => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          list_customer_name: true,
          ...retailerProp,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      retailers.get,
      "post",
      payload,
    );

    if (data) {
      setAllRetailerList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadingUsers = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      companies.get,
      "post",
      payload,
    );

    if (data) {
      setCurrentCompanyData(data.result.metadata[companies.key][0]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadingWorkflow = async (_retailerProp?: any) => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      workflow.get,
      "post",
      payload,
    );

    if (data) {
      setWorkflowList(data.result.metadata?.[workflow.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      setDeleteId(undefined);
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      (async () => {
        setProcess(true);
        stopPolling();
        const deleteResponse = await deleteRecord();
        // if (deleteResponse.data) {
        //   await loadingList({});
        // }
        if (deleteResponse.data) {
          await loadingList({});
          toast({
            title: "Success",
            variant: "success",
            description:
              deleteResponse?.data.result.metadata.message ??
              deleteResponse?.data?.status?.msg ??
              deleteResponse?.data?.status?.message,
          });
        }
        clearDelete();
        setDeleteId(undefined);
        setProcess(false);
        startPolling();
      })();
    }
  }, [status]);

  const deleteRecord = async () => {
    const payload = {
      data: {
        doc_id: deleteId,
        company_id: company_id,
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_URL.delete,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        setPaginationData((prev) => ({ ...prev, page: 1 }));
        sessionStorage.setItem("document-page", "1");
        await loadingList({ page: 1 });
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    stopPolling();
    console.log({ prop });
    console.log(prop);
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    sessionStorage.setItem("document-page", "" + prop);
    await loadingList({ page: prop });
    setProcess(false);
    startPolling();
  };

  const onPerPageChange = async (prop: number) => {
    sessionStorage.setItem("document-perPage", "" + prop);
    sessionStorage.setItem("document-page", "1");
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingList({ perPage: prop, page: 1 });
    setProcess(false);
  };

  const permission: any = [];

  const loadingDetailsData = async (doc_id: string) => {
    const payload = {
      data: {
        doc_id: doc_id,
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      documentsDetails.get,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data: data?.result?.metadata?.domain, error };
  };

  const documentVoid = async ({
    doc_id,
    is_void,
  }: {
    doc_id: string;
    is_void: boolean;
  }) => {
    const payload = {
      data: {
        doc_id: doc_id,
        company_id: company_id,
        is_void: is_void,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      documentsDetails.update,
      "post",
      payload,
    );

    if (data) {
      toast({
        title: "Success",
        variant: "success",
        description:
          data?.result?.metadata?.message || "Record Updated Successfully",
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const onDocumentReprocess = async (prop: any): Promise<any> => {
    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runDocument.post,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    return { data, error };
  };

  const onAction = async ({ action, data }: any) => {
    if (action === "view") {
      stopPolling();
      setProcess(true);
      setSearchParams({ parent: data.doc_id });
      sessionStorage.setItem("parent", "" + data.doc_id);
      sessionStorage.setItem("document-page", "1");
      setParent(data.doc_id);
      await clearFilter({ current_parent_id: data.doc_id });
      setProcess(false);
      startPolling();
    }
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "run-document") {
      const runDocument = await onRunDocument(data?.file_url);
      if (runDocument?.data) {
        await loadingList({});
      }
    }
    if (action === "reprocess-erp") {
      const doc_id = data?.doc_id;
      setReprocessErpId(doc_id);
      const getDomain = await loadingDetailsData(doc_id);
      if (getDomain.data) {
        const erpReprocess = await onErpReprocess({
          doc_id: doc_id,
          domain_id: getDomain.data?.domain_id,
        });
        console.log("erpReprocess", erpReprocess);
        // const runDocument = await onRunDocument(data?.file_url);
        if (erpReprocess.data.job_id) {
          const jobIdReprocess = await getJobId(erpReprocess.data.job_id);
          console.log("jobIdReprocess", jobIdReprocess);
        }
      }
      setReprocessErpId(undefined);
      setProcess(false);
    }
    if (action === "reprocess-document") {
      stopPolling();
      // setProcess(true);
      setReprocessDocumentId(data.doc_id);

      const runDocumentResponse = await onDocumentReprocess(data);

      if (runDocumentResponse.data.job_id) {
        const jobIdReprocess = await getJobId(runDocumentResponse.data.job_id);
        if (jobIdReprocess?.data) {
          await loadingList({});
        }
      }
      // setProcess(false);
      setReprocessDocumentId(undefined);
      startPolling();
    }
    if (action === "delete") {
      setActiveRecordData(data);
      setDeleteId(data.doc_id);
      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this document?",
      });
      await loadingList({});
    }
    if (action === "void") {
      await documentVoid({ doc_id: data.doc_id, is_void: data.is_void });
      await loadingList({});
    }
    if (action === "remove-parent") {
      setSearchParams({});
      sessionStorage.removeItem("parent");
      setParent(undefined);
      await clearFilter({ removeParent: true });
    }
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
    }
  }, [formPopupOpen]);

  const loadingList = async ({
    perPage,
    page,
    filterReset,
    makeFilter,
    isRePolling,
    predefinedFilter,
    current_parent_id,
    removeParent,
    searchText: searchText,
    dateFilterData,
    dateRange,
    dateRangeByFilter,
    filterData,
  }: {
    perPage?: number;
    page?: number;
    filterReset?: boolean;
    makeFilter?: boolean;
    isRePolling?: boolean;
    predefinedFilter?: any;
    current_parent_id?: any;
    removeParent?: any;
    searchText?: string;
    dateFilterData?: any;
    dateRange?: any;
    dateRangeByFilter?: any;
    filterData?: any;
  }) => {
    // let customFilter: any = {};
    // if (filterParam) {
    //   customFilter = JSON.parse(filterParam);
    //   if (!filter?.state) {
    //     // setFilter((prev: any) => ({ ...prev, state: customFilter.state }));
    //     // setSearchParams("");
    //   }
    // }

    let apiFilter = {};

    if (filterReset) {
      setPaginationData((prev) => ({ ...prev, page: 1 }));
      setFilter({});
      sessionStorage.removeItem("document-filter");
    } else {
      apiFilter = filter;
    }
    if (filterData) {
      setPaginationData((prev) => ({ ...prev, page: 1 }));
      setFilter(filterData);
      apiFilter = filterData;
    }
    if (predefinedFilter) {
      try {
        const currentFilter = JSON.parse(predefinedFilter);
        setFilter(currentFilter);
        apiFilter = currentFilter;
      } catch (error) {
        console.error(error);
      }
    }

    let page_no = page || paginationData.page;

    if (makeFilter || dateFilterData || filterData) {
      page_no = 1;
      setPaginationData((prev) => ({ ...prev, page: 1 }));
      sessionStorage.setItem(
        "document-filter",
        JSON.stringify(filterData || filter),
      );
    }

    let parent = {};
    if (parent_id || current_parent_id) {
      parent = {
        parent_id: [parent_id || current_parent_id],
      };
    }

    if (removeParent) {
      parent = {};
    }

    if (searchText) {
      page_no = 1;
      setPaginationData((prev) => ({ ...prev, page: 1 }));
    }

    if (page) {
      page_no = page;
      setPaginationData((prev) => ({ ...prev, page: page }));
    }

    const selected_date_range = dateRange || dateFilterData || dateFilter;
    const selected_search = searchText ?? searchDebounced;
    const selected_date_range_by = dateRangeByFilter || dateRangeBy;

    const payload = {
      data: {
        filter_by: {
          ...apiFilter,
          // Deleted documents are listed only under the "Deleted" tab
          is_deleted: (apiFilter as any)?.is_deleted === true,
          ...parent,
          date_range: parent_id ? [] : selected_date_range,
          date_range_by: selected_date_range_by,
          search_on: [],
          include_columns: [],
          search_text: parent_id ? "" : selected_search,
          exact_match: false,
          pagination: {
            page_no: page_no,
            no_of_recs: perPage || paginationData.perPage,
            sort_by: "cts",
            order_by: false,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
      timezone: timeZone,
    };
    const { data, error, message } = await apiServices<any>(
      API_URL.get,
      "post",
      payload,
    );

    if (data) {
      const listData = (data.result.metadata[API_URL.key] || []).map(
        (item: any) => ({
          ...item,
          erp_customer_name: item?.erp_customer_info?.customer_name,
        }),
      );
      setListData(listData);
      setDashboardDetails({
        ...data.result.metadata["dashboard_details"],
        totalCount: data?.result?.metadata?.total_records || 0,
      });
      if (isRePolling !== true) {
        // const retailerIdList = listData?.map((item: any) => item.retailer_id);
        // await loadingRetailer({ retailer_id: retailerIdList || [] });
        await loadingWorkflow();
        await loadingUsers();
      }
      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const getJobId = async (prop: string, isInProgressExist?: boolean) => {
    while (true) {
      const { data, error, message } = await apiServices<any>(
        jobId.get + prop,
        "get",
      );

      if (data?.process_status !== "in-progress" || isInProgressExist) {
        if (data?.error) {
          toast({
            title: "Error",
            variant: "destructive",
            description: error.status?.message || message,
          });
        }

        if (data?.status?.error_details?.fail_message) {
          toast({
            title: "Error",
            variant: "destructive",
            description: data.status.error_details.fail_message,
          });
          return { data: null, error: data.status.error_details.fail_message };
        }

        return { data, error };
      }

      await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before next call
    }
  };

  const onFormSubmit = async (prop: any): Promise<any> => {
    if (!prop) return;
    setProcess(true);
    const payload = new FormData();

    payload.append("files", prop);

    const { data, error, message } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload,
    );

    if (data) {
      const runDocument = await onRunDocument(data.metadata.file_path);

      await getJobId(runDocument.data.job_id, true);

      await loadingList({});
    }

    if (error) {
      setProcess(false);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    setProcess(false);
  };
  const onRunDocument = async (prop: any): Promise<any> => {
    setProcess(true);

    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runDocument.post,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const onErpReprocess = async (formData: any): Promise<any> => {
    // setProcess(true);

    const payload = {
      data: {
        doc_id: formData.doc_id,
        domain_id: formData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runErpReprocess.post,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const uploadDocument = async (file_path: File) => {
    const payload = new FormData();

    payload.append("files", file_path);

    const { data, error, message } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload,
    );
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
      return { data, error, message };
    }

    return { data: data?.metadata?.file_path, error, message };
  };

  const formSubmitHandle = async (prop: any) => {
    setFormPopup(false);
    if (!prop) return;
    setProcess(true);

    let results: any = null;
    let documentPayload = null;

    if (prop?.isMultiUpload) {
      const file_path_list: any = [];

      results = await Promise.all(
        (prop?.file_path ?? []).map((filePath: any) =>
          uploadDocument(filePath.file),
        ),
      );
      results.forEach((element: any, index: number) => {
        if (element?.data) {
          file_path_list.push({
            file: element?.data,
            document_type: prop?.file_path?.[index]?.document_type,
          });
        }
      });
      documentPayload = {
        file_path: file_path_list,
        workflow_id: prop.workflow_id,
        retailer_id: prop.retailer_id,
      };
      if (file_path_list?.length === 0) {
        setProcess(false);
      } else {
        const runDocument = await onRunDocument(documentPayload);
        await getJobId(runDocument.data.job_id, true);
        await loadingList({});
      }

      if (results.error) {
        setProcess(false);
      }

      if (results.error) {
        toast({
          title: "Error",
          variant: "destructive",
          description: results?.error.status?.message || results?.message,
        });
      }
      setProcess(false);
    } else {
      results = await uploadDocument(prop?.file_path);
      documentPayload = {
        file_path: results.data,
        workflow_id: prop.workflow_id,
        retailer_id: prop.retailer_id,
      };
      if (results?.data) {
        const runDocument = await onRunDocument(documentPayload);
        await getJobId(runDocument.data.job_id, true);
        await loadingList({});
      }

      if (results.error) {
        setProcess(false);
      }

      if (results.error) {
        toast({
          title: "Error",
          variant: "destructive",
          description: results?.error.status?.message || results?.message,
        });
      }
      setProcess(false);
      return results;
    }
  };

  const filterRequest = async (filterProp?: any) => {
    setProcess(true);
    if (filterProp) {
      await loadingList({ makeFilter: true, page: 1, filterData: filterProp });
    } else {
      await loadingList({ makeFilter: true, page: 1 });
    }
    setProcess(false);
  };
  const clearFilter = async ({ removeParent, current_parent_id }: any) => {
    setFilter({});
    setProcess(true);
    await loadingList({
      filterReset: true,
      page: 1,
      removeParent,
      current_parent_id,
    });
    setProcess(false);
  };

  useEffect(() => {
    if (parent === undefined && isLoading) {
      (async () => {
        setSearchParams({});
        sessionStorage.removeItem("parent");
        setParent(undefined);
        setSearchParams({});
        await clearFilter({ removeParent: true });
      })();
    }
  }, [parent]);

  const onDateChange = async (prop: any) => {
    setDateFilter(prop);
    if (parent) {
      sessionStorage.setItem("parent-date-filter", JSON.stringify(prop));
    } else {
      sessionStorage.setItem("date-filter", JSON.stringify(prop));
    }
    setProcess(true);
    await loadingList({ dateFilterData: prop, page: 1 });
    setProcess(false);
  };

  const handleDateRangeBy = async (
    prop: "order_date" | "delivery_date" | "processed_date",
  ) => {
    setDateRangeBy(prop);
    setProcess(true);
    await loadingList({ dateRangeByFilter: prop });
    setProcess(false);
  };

  const cashBalanceReport = async () => {
    console.log({ allRetailerList });
    const tempSelectedRecord =
      selectedRecord?.length > 0
        ? selectedRecord
        : allRetailerList?.map((item: any) => item.retailer_id);
    setProcess(true);

    const payload: any = {
      data: {
        filter_by: {
          date_range: tempDate || dateFilter,
        },
        outlets: [],
      },
      company_id: company_id,
      user_id: user_id,
      timezone: timeZone,
    };
    if (isAdmin) {
      payload.data["outlets"] = tempSelectedRecord;
    }
    const { data, error, message } = await apiServices<any>(
      dsr_report_endpoint.get,
      "post",
      payload,
    );

    if (data.result.metadata?.cash_balance_report) {
      const tempUrl = data.result.metadata.cash_balance_report;

      const finalUrl = await getFileUrl(tempUrl);

      // Extract filename from URL
      const fileName = tempUrl.split("/").pop() || "download.xlsx";

      const link = document.createElement("a");
      link.href = finalUrl;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  const formatDate = (value: any) => {
    try {
      if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return value;
      }
      if (value?.toDate) {
        return format(value.toDate(), "dd-MM-yyyy");
      }
      return format(new Date(value as any), "dd-MM-yyyy");
    } catch (error) {
      return value;
    }
  };

  const onTempDateChange = (prop: any) => {
    setTempDate([formatDate(prop[0]), formatDate(prop[1])]);
  };

  return {
    skeltonLoading,
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
    companyData,
    retailerList,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    formPopup,
    setFormPopup,
    formSubmitHandle,
    workflowList,
    currentCompanyData,
    reprocessDocumentId,
    reprocessErpId,
    parent_id,
    autoPolling,
    setAutoPolling,
    onDateChange,
    dateFilter,
    company_id,
    user_id,
    loadingList,
    handleDateRangeBy,
    dateRangeBy,
    dashboardDetails,
    selectedRecord,
    setSelectedRecord,
    cashBalanceReport,
    allRetailerList,
    isAdmin,
    currentUser,
    onTempDateChange,
  };
};

// /* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { useGlobalSearch, useProcess } from "@/global-data";
// import { useDeletePopup } from "@/global-data/use-delete-popup";
// import { useDebouncedValue } from "@/hooks/use-debounced-value";
// import { getUserInfo } from "@/lib/token";
// import { wait } from "@/lib/wait";
// import { apiServices } from "@/services/api.services";
// import { useEffect, useMemo, useState } from "react";
// import {
//   companies,
//   documents,
//   documentsDetails,
//   documentsUpload,
//   jobId,
//   // retailers,
//   runDocument,
//   runErpReprocess,
//   workflow,
// } from "@/services/global.services";

// import { useSearchParams } from "react-router-dom";
// import { useToast } from "@/hooks/use-toast";
// import useAutoPolling from "@/hooks/use-auto-polling";
// import { useParentDocument } from "@/global-data/use-parent-document";
// import { DateObject } from "react-multi-date-picker";
// import { format } from "date-fns";
// import { getCurrentTimeZone } from "@/lib/utils";

// export const useMutations = () => {
//   const timeZone = getCurrentTimeZone();
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [isLoading, setIsLoading] = useState(false);
//   const [reprocessDocumentId, setReprocessDocumentId] = useState(undefined);
//   const [reprocessErpId, setReprocessErpId] = useState(undefined);
//   const filterParam = searchParams.get("filter");
//   const parent_id = searchParams.get("parent");
//   const [autoPolling, setAutoPolling] = useState(true);
//   const [dashboardDetails, setDashboardDetails] = useState(undefined);
//   const API_URL = useMemo(() => {
//     return documents;
//   }, [documents]);
//   const { company_id, user_id } = useMemo(() => {
//     const tempUserData = getUserInfo();
//     return {
//       company_id: tempUserData?.company_id,
//       user_id: tempUserData?.user_id || "",
//     };
//   }, []);

//   const pageReset = searchParams.get("page");

//   const { setProcess } = useProcess();
//   const [skeltonLoading, setSkeltonLoading] = useState(true);
//   const [listData, setListData] = useState([]);
//   const [retailerList, _setRetailerList] = useState([]);
//   const [currentCompanyData, setCurrentCompanyData] = useState([]);
//   const [companyData, _setCompanyData] = useState([]);
//   const [workflowList, setWorkflowList] = useState([]);
//   const [formPopupOpen, setFormPopupOpen] = useState(false);
//   const [activeRecordData, setActiveRecordData] = useState(undefined);
//   const [tableColumn, setTableColumn] = useState([]);
//   const [deleteId, setDeleteId] = useState(undefined);
//   const { setSearchProgress, search } = useGlobalSearch();
//   const [searchDebounced] = useDebouncedValue(search, 200);
//   const [filter, setFilter] = useState<any>({});
//   const [formPopup, setFormPopup] = useState<boolean>(false);
//   const [dateRangeBy, setDateRangeBy] = useState<
//     "processed_date" | "delivery_date" | "order_date"
//   >("processed_date");

//   const [dateFilter, setDateFilter] = useState<any>();

//   const fetchData = async () => {
//     await loadingList({ isRePolling: true });
//   };

//   const { startPolling, stopPolling } = useAutoPolling(fetchData, 5000);
//   const { setParent, parent } = useParentDocument();
//   const { toast } = useToast();

//   const { onDelete, status, identity, clearDelete } = useDeletePopup();

//   const [paginationData, setPaginationData] = useState({
//     page: sessionStorage.getItem("document-page")
//       ? Number(sessionStorage.getItem("document-page"))
//       : 1,
//     perPage: sessionStorage.getItem("document-perPage")
//       ? Number(sessionStorage.getItem("document-perPage"))
//       : 10,
//     totalItem: 1,
//   });

//   useEffect(() => {
//     if (autoPolling) {
//       startPolling();
//     } else {
//       stopPolling();
//     }
//   }, [autoPolling]);

//   useEffect(() => {
//     if (Object.keys(filter).length > 0) {
//       sessionStorage.setItem("document-filter", JSON.stringify(filter));
//     }
//   }, [filter]);

//   const { pathname } = location;

//   const getRangeDate = (keys: string) => {
//     try {
//       const tempDate = sessionStorage.getItem(keys);
//       return JSON.parse(tempDate || "");
//     } catch (error) {
//       const end = new DateObject().format("DD-MM-YYYY");
//       // const start = new DateObject(end)
//       //   .subtract(29, "days")
//       //   .format("DD-MM-YYYY");
//       const startDate = new DateObject(end).subtract(29, "days").toDate();

//       const start = format(startDate, "dd-MM-yyyy"); // using date-fns

//       return [start, end];
//     }
//   };

//   useEffect(() => {
//     (async () => {
//       if (pageReset) {
//         setSearchParams({});
//         sessionStorage.removeItem("parent");
//         sessionStorage.setItem("document-page", "1");
//         const dateRange = getRangeDate("parent-date-filter");
//         setProcess(true);
//         await loadingList({
//           searchText: "",
//           dateRange: dateRange || [],
//           page: 1,
//         });
//         setProcess(false);
//       }
//     })();
//   }, [pageReset]);

//   //On Load Component
//   useEffect(() => {
//     const predefinedFilter = sessionStorage.getItem("document-filter");
//     let parent = sessionStorage.getItem("parent");
//     const removeParent = sessionStorage.getItem("remove_parent");
//     if (removeParent) {
//       sessionStorage.removeItem("remove_parent");
//       parent = null;
//     }
//     const key = parent ? `search-${pathname}-parent` : `search-${pathname}`;
//     const current_page = sessionStorage.getItem("document-page");

//     setPaginationData((prev) => ({
//       ...prev,
//       page: current_page ? Number(current_page) : 1,
//     }));

//     let dateRange = [];
//     if (parent) {
//       dateRange = getRangeDate("parent-date-filter");
//     } else {
//       dateRange = getRangeDate("date-filter");
//     }

//     if (dateRange?.[0] && dateRange?.[1]) {
//       setDateFilter(dateRange);
//     } else {
//       const startDate = new DateObject({ format: "DD-MM-YYYY" }).subtract(
//         6,
//         "days",
//       );
//       const endDate = new DateObject({ format: "DD-MM-YYYY" });
//       //  setDateFilter;
//       setDateFilter([startDate, endDate]);
//       dateRange = [startDate, endDate];
//     }

//     let searchText = sessionStorage.getItem(key);

//     if (filterParam) {
//       const customFilter = JSON.parse(filterParam);
//       if (customFilter?.state?.[0]) {
//         searchText = customFilter?.state?.[0];
//       }
//     }

//     (async () => {
//       if (parent) {
//         setSearchParams({ parent: parent });
//         setParent(parent);
//       }
//       await loadingList({
//         predefinedFilter,
//         current_parent_id: parent,
//         searchText: searchText || "",
//         dateRange,
//         page: current_page ? Number(current_page) : 1,
//       });
//       await wait(1000);
//       setSkeltonLoading(false);
//       setIsLoading(true);
//     })();
//   }, []);

//   // const loadingRetailer = async (retailerProp?: any) => {
//   //   const payload = {
//   //     data: {
//   //       filter_by: {
//   //         search_text: "",
//   //         exact_match: false,
//   //         ...retailerProp,
//   //       },
//   //     },
//   //     company_id: company_id,
//   //     user_id: user_id,
//   //   };
//   //   const { data, error, message } = await apiServices<any>(
//   //     retailers.get,
//   //     "post",
//   //     payload
//   //   );

//   //   if (data) {
//   //     setRetailerList(data.result.metadata?.[retailers.key]);
//   //   }

//   //   if (error) {
//   //     toast({
//   //       title: "Error",
//   //       variant: "destructive",
//   //       description: error.status?.message || message,
//   //     });
//   //   }
//   //   return { data, error };
//   // };

//   const loadingUsers = async () => {
//     const payload = {
//       data: {
//         filter_by: {
//           company_id: [company_id],
//           search_text: "",
//           exact_match: false,
//         },
//       },
//       company_id: company_id,
//       user_id: user_id,
//     };
//     const { data, error, message } = await apiServices<any>(
//       companies.get,
//       "post",
//       payload,
//     );

//     if (data) {
//       setCurrentCompanyData(data.result.metadata[companies.key][0]);
//     }
//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   const loadingWorkflow = async (_retailerProp?: any) => {
//     const payload = {
//       data: {
//         filter_by: {
//           search_text: "",
//           exact_match: false,
//         },
//       },
//       company_id: company_id,
//       user_id: user_id,
//     };
//     const { data, error, message } = await apiServices<any>(
//       workflow.get,
//       "post",
//       payload,
//     );

//     if (data) {
//       setWorkflowList(data.result.metadata?.[workflow.key]);
//     }

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   //handle delete
//   useEffect(() => {
//     if (status === "cancel") {
//       setDeleteId(undefined);
//       clearDelete();
//     }
//     if (status === "delete" && identity === "user") {
//       (async () => {
//         setProcess(true);
//         stopPolling();
//         const deleteResponse = await deleteRecord();
//         // if (deleteResponse.data) {
//         //   await loadingList({});
//         // }
//         if (deleteResponse.data) {
//           await loadingList({});
//           toast({
//             title: "Success",
//             variant: "success",
//             description:
//               deleteResponse?.data.result.metadata.message ??
//               deleteResponse?.data?.status?.msg ??
//               deleteResponse?.data?.status?.message,
//           });
//         }
//         clearDelete();
//         setDeleteId(undefined);
//         setProcess(false);
//         startPolling();
//       })();
//     }
//   }, [status]);

//   const deleteRecord = async () => {
//     const payload = {
//       data: {
//         doc_id: deleteId,
//         company_id: company_id,
//       },
//       company_id: company_id,
//     };
//     const { data, error, message } = await apiServices<any>(
//       API_URL.delete,
//       "post",
//       payload,
//     );

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   //Handle Search
//   useEffect(() => {
//     if (skeltonLoading === false) {
//       (async () => {
//         setSearchProgress(true);
//         setPaginationData((prev) => ({ ...prev, page: 1 }));
//         sessionStorage.setItem("document-page", "1");
//         await loadingList({ page: 1 });
//         setSearchProgress(false);
//       })();
//     }
//   }, [searchDebounced]);

//   const onFormOpenChange = (prop: boolean) => {
//     setFormPopupOpen(prop);
//   };

//   const onPageChange = async (prop: number) => {
//     stopPolling();
//     console.log({ prop });
//     console.log(prop);
//     setPaginationData((prev) => ({ ...prev, page: prop }));
//     setProcess(true);
//     sessionStorage.setItem("document-page", "" + prop);
//     await loadingList({ page: prop });
//     setProcess(false);
//     startPolling();
//   };

//   const onPerPageChange = async (prop: number) => {
//     sessionStorage.setItem("document-perPage", "" + prop);
//     sessionStorage.setItem("document-page", "1");
//     setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
//     setProcess(true);
//     await loadingList({ perPage: prop, page: 1 });
//     setProcess(false);
//   };

//   const permission: any = [];

//   const loadingDetailsData = async (doc_id: string) => {
//     const payload = {
//       data: {
//         doc_id: doc_id,
//       },
//       company_id: company_id,
//       user_id: user_id,
//     };
//     const { data, error, message } = await apiServices<any>(
//       documentsDetails.get,
//       "post",
//       payload,
//     );

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data: data?.result?.metadata?.domain, error };
//   };

//   const onDocumentReprocess = async (prop: any): Promise<any> => {
//     const payload = {
//       data: prop,
//       company_id: company_id,
//       user_id: user_id,
//     };

//     const { data, error, message } = await apiServices<any>(
//       runDocument.post,
//       "post",
//       payload,
//     );

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }

//     return { data, error };
//   };

//   const onAction = async ({ action, data }: any) => {
//     if (action === "view") {
//       stopPolling();
//       setProcess(true);
//       setSearchParams({ parent: data.doc_id });
//       sessionStorage.setItem("parent", "" + data.doc_id);
//       sessionStorage.setItem("document-page", "1");
//       setParent(data.doc_id);
//       await clearFilter({ current_parent_id: data.doc_id });
//       setProcess(false);
//       startPolling();
//     }
//     if (action === "edit") {
//       setActiveRecordData(data);
//       onFormOpenChange(true);
//     }
//     if (action === "run-document") {
//       const runDocument = await onRunDocument(data?.file_url);
//       if (runDocument?.data) {
//         await loadingList({});
//       }
//     }
//     if (action === "reprocess-erp") {
//       const doc_id = data?.doc_id;
//       setReprocessErpId(doc_id);
//       const getDomain = await loadingDetailsData(doc_id);
//       if (getDomain.data) {
//         const erpReprocess = await onErpReprocess({
//           doc_id: doc_id,
//           domain_id: getDomain.data?.domain_id,
//         });
//         console.log("erpReprocess", erpReprocess);
//         // const runDocument = await onRunDocument(data?.file_url);
//         if (erpReprocess.data.job_id) {
//           const jobIdReprocess = await getJobId(erpReprocess.data.job_id);
//           console.log("jobIdReprocess", jobIdReprocess);
//         }
//       }
//       setReprocessErpId(undefined);
//       setProcess(false);
//     }
//     if (action === "reprocess-document") {
//       stopPolling();
//       // setProcess(true);
//       setReprocessDocumentId(data.doc_id);

//       const runDocumentResponse = await onDocumentReprocess(data);

//       if (runDocumentResponse.data.job_id) {
//         const jobIdReprocess = await getJobId(runDocumentResponse.data.job_id);
//         if (jobIdReprocess?.data) {
//           await loadingList({});
//         }
//       }
//       // setProcess(false);
//       setReprocessDocumentId(undefined);
//       startPolling();
//     }
//     if (action === "delete") {
//       setActiveRecordData(data);
//       setDeleteId(data.doc_id);
//       onDelete({
//         description:
//           "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
//         id: data.user_id,
//         identity: "user",
//         popupStatus: true,
//         title: "Are you sure you want to delete this document?",
//       });
//       await loadingList({});
//     }
//     if (action === "remove-parent") {
//       setSearchParams({});
//       sessionStorage.removeItem("parent");
//       setParent(undefined);
//       await clearFilter({ removeParent: true });
//     }
//   };

//   useEffect(() => {
//     if (formPopupOpen === false) {
//       setActiveRecordData(undefined);
//     }
//   }, [formPopupOpen]);

//   const loadingList = async ({
//     perPage,
//     page,
//     filterReset,
//     makeFilter,
//     isRePolling,
//     predefinedFilter,
//     current_parent_id,
//     removeParent,
//     searchText: searchText,
//     dateFilterData,
//     dateRange,
//     dateRangeByFilter,
//   }: {
//     perPage?: number;
//     page?: number;
//     filterReset?: boolean;
//     makeFilter?: boolean;
//     isRePolling?: boolean;
//     predefinedFilter?: any;
//     current_parent_id?: any;
//     removeParent?: any;
//     searchText?: string;
//     dateFilterData?: any;
//     dateRange?: any;
//     dateRangeByFilter?: any;
//   }) => {
//     // let customFilter: any = {};
//     // if (filterParam) {
//     //   customFilter = JSON.parse(filterParam);
//     //   if (!filter?.state) {
//     //     // setFilter((prev: any) => ({ ...prev, state: customFilter.state }));
//     //     // setSearchParams("");
//     //   }
//     // }

//     let apiFilter = {};

//     if (filterReset) {
//       setPaginationData((prev) => ({ ...prev, page: 1 }));
//       setFilter({});
//       sessionStorage.removeItem("document-filter");
//     } else {
//       apiFilter = filter;
//     }

//     if (predefinedFilter) {
//       try {
//         const currentFilter = JSON.parse(predefinedFilter);
//         setFilter(currentFilter);
//         apiFilter = currentFilter;
//       } catch (error) {
//         console.error(error);
//       }
//     }

//     let page_no = page || paginationData.page;

//     if (makeFilter || dateFilterData) {
//       page_no = 1;
//       setPaginationData((prev) => ({ ...prev, page: 1 }));
//       sessionStorage.setItem("document-filter", JSON.stringify(filter));
//     }

//     let parent = {};
//     if (parent_id || current_parent_id) {
//       parent = {
//         parent_id: [parent_id || current_parent_id],
//       };
//     }

//     if (removeParent) {
//       parent = {};
//     }

//     if (searchText) {
//       page_no = 1;
//       setPaginationData((prev) => ({ ...prev, page: 1 }));
//     }

//     if (page) {
//       page_no = page;
//       setPaginationData((prev) => ({ ...prev, page: page }));
//     }

//     const selected_date_range = dateRange || dateFilterData || dateFilter;
//     const selected_search = searchText ?? searchDebounced;
//     const selected_date_range_by = dateRangeByFilter || dateRangeBy;

//     const payload = {
//       data: {
//         filter_by: {
//           // ...customFilter,
//           ...apiFilter,
//           ...parent,
//           date_range: parent_id ? [] : selected_date_range,
//           date_range_by: selected_date_range_by,
//           search_on: [],
//           include_columns: [],
//           search_text: parent_id ? "" : selected_search,
//           exact_match: false,
//           pagination: {
//             page_no: page_no,
//             no_of_recs: perPage || paginationData.perPage,
//             sort_by: "cts",
//             order_by: false,
//           },
//         },
//       },
//       company_id: company_id,
//       user_id: user_id,
//       timezone: timeZone,
//     };
//     const { data, error, message } = await apiServices<any>(
//       API_URL.get,
//       "post",
//       payload,
//     );

//     if (data) {
//       const listData = data.result.metadata[API_URL.key];
//       setListData(listData);
//       setDashboardDetails(data.result.metadata["dashboard_details"]);
//       if (isRePolling !== true) {
//         // const retailerIdList = listData?.map((item: any) => item.retailer_id);
//         // await loadingRetailer({ retailer_id: retailerIdList || [] });
//         await loadingWorkflow();
//         await loadingUsers();
//       }
//       setPaginationData((prev) => ({
//         ...prev,
//         totalItem: data?.result?.metadata?.total_records || 1,
//       }));
//     }
//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   const getJobId = async (prop: string, isInProgressExist?: boolean) => {
//     while (true) {
//       const { data, error, message } = await apiServices<any>(
//         jobId.get + prop,
//         "get",
//       );

//       if (data?.process_status !== "in-progress" || isInProgressExist) {
//         if (data?.error) {
//           toast({
//             title: "Error",
//             variant: "destructive",
//             description: error.status?.message || message,
//           });
//         }

//         if (data?.status?.error_details?.fail_message) {
//           toast({
//             title: "Error",
//             variant: "destructive",
//             description: data.status.error_details.fail_message,
//           });
//           return { data: null, error: data.status.error_details.fail_message };
//         }

//         return { data, error };
//       }

//       await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before next call
//     }
//   };

//   const onFormSubmit = async (prop: any): Promise<any> => {
//     if (!prop) return;
//     setProcess(true);
//     const payload = new FormData();

//     payload.append("files", prop);

//     const { data, error, message } = await apiServices<any>(
//       documentsUpload.post + "/" + company_id,
//       "post",
//       payload,
//     );

//     if (data) {
//       const runDocument = await onRunDocument(data.metadata.file_path);

//       await getJobId(runDocument.data.job_id, true);

//       await loadingList({});
//     }

//     if (error) {
//       setProcess(false);
//     }

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }

//     setProcess(false);
//   };
//   const onRunDocument = async (prop: any): Promise<any> => {
//     setProcess(true);

//     const payload = {
//       data: prop,
//       company_id: company_id,
//       user_id: user_id,
//     };

//     const { data, error, message } = await apiServices<any>(
//       runDocument.post,
//       "post",
//       payload,
//     );

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   const onErpReprocess = async (formData: any): Promise<any> => {
//     // setProcess(true);

//     const payload = {
//       data: {
//         doc_id: formData.doc_id,
//         domain_id: formData.domain_id,
//       },
//       company_id: company_id,
//       user_id: user_id,
//     };

//     const { data, error, message } = await apiServices<any>(
//       runErpReprocess.post,
//       "post",
//       payload,
//     );

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }
//     return { data, error };
//   };

//   const formSubmitHandle = async (prop: any) => {
//     setFormPopup(false);
//     if (!prop) return;
//     setProcess(true);
//     const payload = new FormData();

//     payload.append("files", prop?.file_path);

//     const { data, error, message } = await apiServices<any>(
//       documentsUpload.post + "/" + company_id,
//       "post",
//       payload,
//     );

//     if (data) {
//       const documentPayload = {
//         file_path: data.metadata.file_path,
//         workflow_id: prop.workflow_id,
//       };
//       const runDocument = await onRunDocument(documentPayload);

//       await getJobId(runDocument.data.job_id, true);

//       await loadingList({});
//     }

//     if (error) {
//       setProcess(false);
//     }

//     if (error) {
//       toast({
//         title: "Error",
//         variant: "destructive",
//         description: error.status?.message || message,
//       });
//     }

//     return { data: data?.metadata?.file_path, error, message };
//   };

//   const formSubmitHandle = async (prop: any) => {
//     setFormPopup(false);
//     if (!prop) return;
//     setProcess(true);

//     let results: any = null;
//     let documentPayload = null;

//     if (prop?.isMultiUpload) {
//       const file_path_list: any = [];

//       results = await Promise.all(
//         (prop?.file_path ?? []).map((filePath: any) =>
//           uploadDocument(filePath.file),
//         ),
//       );
//       results.forEach((element: any, index: number) => {
//         if (element?.data) {
//           file_path_list.push({
//             file: element?.data,
//             document_type: prop?.file_path?.[index]?.document_type,
//           });
//         }
//       });
//       documentPayload = {
//         file_path: file_path_list,
//         workflow_id: prop.workflow_id,
//       };
//       if (file_path_list?.length === 0) {
//         setProcess(false);
//       } else {
//         const runDocument = await onRunDocument(documentPayload);
//         await getJobId(runDocument.data.job_id, true);
//         await loadingList({});
//       }

//       if (results.error) {
//         setProcess(false);
//       }

//       if (results.error) {
//         toast({
//           title: "Error",
//           variant: "destructive",
//           description: results?.error.status?.message || results?.message,
//         });
//       }
//       setProcess(false);
//     } else {
//       results = await uploadDocument(prop?.file_path);
//       documentPayload = {
//         file_path: results.data,
//         workflow_id: prop.workflow_id,
//       };
//       if (results?.data) {
//         const runDocument = await onRunDocument(documentPayload);
//         await getJobId(runDocument.data.job_id, true);
//         await loadingList({});
//       }

//       if (results.error) {
//         setProcess(false);
//       }

//       if (results.error) {
//         toast({
//           title: "Error",
//           variant: "destructive",
//           description: results?.error.status?.message || results?.message,
//         });
//       }
//       setProcess(false);
//       return results;
//     }
//   };

//   const filterRequest = async () => {
//     setProcess(true);
//     await loadingList({ makeFilter: true, page: 1 });
//     setProcess(false);
//   };
//   const clearFilter = async ({ removeParent, current_parent_id }: any) => {
//     setFilter({});
//     setProcess(true);
//     await loadingList({
//       filterReset: true,
//       page: 1,
//       removeParent,
//       current_parent_id,
//     });
//     setProcess(false);
//   };

//   useEffect(() => {
//     if (parent === undefined && isLoading) {
//       (async () => {
//         setSearchParams({});
//         sessionStorage.removeItem("parent");
//         setParent(undefined);
//         setSearchParams({});
//         await clearFilter({ removeParent: true });
//       })();
//     }
//   }, [parent]);

//   const onDateChange = async (prop: any) => {
//     setDateFilter(prop);
//     if (parent) {
//       sessionStorage.setItem("parent-date-filter", JSON.stringify(prop));
//     } else {
//       sessionStorage.setItem("date-filter", JSON.stringify(prop));
//     }
//     setProcess(true);
//     await loadingList({ dateFilterData: prop, page: 1 });
//     setProcess(false);
//   };

//   const handleDateRangeBy = async (
//     prop: "order_date" | "delivery_date" | "processed_date",
//   ) => {
//     setDateRangeBy(prop);
//     setProcess(true);
//     await loadingList({ dateRangeByFilter: prop });
//     setProcess(false);
//   };

//   return {
//     skeltonLoading,
//     listData,
//     onPageChange,
//     onPerPageChange,
//     paginationData,
//     permission,
//     onAction,
//     activeRecordData,
//     onFormSubmit,
//     onFormOpenChange,
//     formPopupOpen,
//     tableColumn,
//     setTableColumn,
//     companyData,
//     retailerList,
//     filter,
//     setFilter,
//     filterRequest,
//     clearFilter,
//     formPopup,
//     setFormPopup,
//     formSubmitHandle,
//     workflowList,
//     currentCompanyData,
//     reprocessDocumentId,
//     reprocessErpId,
//     parent_id,
//     autoPolling,
//     setAutoPolling,
//     onDateChange,
//     dateFilter,
//     company_id,
//     user_id,
//     loadingList,
//     handleDateRangeBy,
//     dateRangeBy,
//     dashboardDetails,
//   };
// };
